import type { Except } from "type-fest";
import {
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "../date-time/iso-and-unix";
import type { EntityState } from "../entity-status";
import type { ProviderId } from "../providers/provider-id";
import type { UserId } from "../users/user-id";
import {
    bulkPurchaseGroupIdFactory,
    type BulkPurchaseGroupId,
} from "./bulk-purchase-group-id";

type BulkPurchaseGroup = {
    _id: BulkPurchaseGroupId;
    _type: "BULK_PURCHASE_GROUP";
    _createdAt: IsoAndUnixTimestamp;
    _status: EntityState;
    createdBy: UserId;
    name: string;
    providerId: ProviderId;
};

type TicketCreateParams = Except<
    BulkPurchaseGroup,
    "_id" | "_createdAt" | "_type" | "_status"
> & {
    _id?: BulkPurchaseGroupId;
};

const bulkPurchaseGroupFactory = (
    params: TicketCreateParams,
): BulkPurchaseGroup => {
    const now = nowIsoAndUnix();
    return {
        ...params,
        _id: params._id ?? bulkPurchaseGroupIdFactory(),
        _createdAt: now,
        _status: "ACTIVE",
        _type: "BULK_PURCHASE_GROUP",
    };
};

export { bulkPurchaseGroupFactory };
export type { BulkPurchaseGroup };
